import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'antd'

import PopupModal from 'Shared/Components/PopupModal'
import { Checkbox, Dropdown, FormContainer, PasswordInput, TextInput } from 'Shared/Components/FormComponents'
import useCommonAPI from 'Shared/API/Common'
import { showSuccess } from 'Shared/Components/NotifyToast'
import { useOutletContext } from 'react-router-dom'
import useSmartwatchAPI from 'Shared/API/Smartwatch'
import { apiUrl } from 'Shared/utils'
import useFetchData from 'Shared/Hooks/useFetchData'

const RouterFormContent = ({ device, mode, onFinish }) => {  
  return (
    <div></div>
  )
}

const RouterFormModal = ({ isOpen, device, mode, onClose, loadData }) => {
    const { setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const { send } = useFetchData()

  const onFinish = async (values) => {    
    setPageLoading(true)

    // if (mode == "Create") {
    //   const res = await send({
    //     method: "POST",
    //     url: `${apiUrl}/camera/device`,
    //     contentType: "json",
    //     body: {
    //       "camera_id": values["cameraId"],
    //       "camera_name": values["cameraName"],
    //       "project": values["project"],
    //       "model": values["model"],
    //       "sn": values["sn"],
    //       "ip": values["ip"],
    //       "http_port": values["http_port"],
    //       "ai_enabled": values["ai_enabled"],
    //       "usr": values["usr"],
    //       "pwd": values["pwd"],
    //     }
    //   })

    //   if (res != null) {
    //     onClose()
    //     showSuccess(t("general_success"))

    //     loadData()
    //   }
    // }
    // else if (mode == "Edit") {
    //   const res = await send({
    //     method: "PUT",
    //     url: `${apiUrl}/camera/device/${camera["camera_id"]}`,
    //     contentType: "json",
    //     body: {
    //       "camera_name": values["cameraName"],
    //       "project": values["project"],
    //       "model": values["model"],
    //       "sn": values["sn"],
    //       "ip": values["ip"],
    //       "http_port": values["http_port"],
    //       "ai_enabled": values["ai_enabled"],
    //       "usr": values["usr"],
    //       "pwd": values["pwd"],
    //     }
    //   })

    //   if (res != null) {
    //     onClose()
    //     showSuccess(t("general_success"))

    //     loadData()
    //   }
    // }
    // else if (mode == "Delete") {
    //   const res = await send({
    //     method: "DELETE",
    //     url: `${apiUrl}/camera/device/${camera["camera_id"]}`,
    //     contentType: "json"
    //   })

    //   if (res != null) {
    //     onClose()
    //     showSuccess(t("general_success"))

    //     loadData()
    //   }
    // }

    setPageLoading(false)
  }

  return (
    <PopupModal isOpen={isOpen} close toggle={() => onClose()} width="80%" maxHeight="80%">
      <RouterFormContent device={device} mode={mode} onFinish={onFinish} />
    </PopupModal>
  )
}

export default RouterFormModal
